import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=7ec7987c&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=ts"
export * from "./NewOrder.vue?vue&type=script&lang=ts"
import style0 from "./NewOrder.vue?vue&type=style&index=0&id=7ec7987c&prod&scoped=true&lang=css"
import style1 from "./NewOrder.vue?vue&type=style&index=1&id=7ec7987c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec7987c",
  null
  
)

export default component.exports